import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-task-status-color',
    templateUrl: './task-status-color.component.html',
    styleUrl: './task-status-color.component.scss'
})
export class TaskStatusColorComponent {

    @Input() public taskStatus = '';

}
